import React from 'react';
import {
  Container,
  Title,
  ComparisonTable,
  TableHeader,
  MethodsHeader,
  CoursesHeader,
  FluenciAHeader,
  TableRow,
  MethodColumn,
  CourseColumn,
  FluenciAColumn,
  CheckIcon
} from './styles';

const Section3 = () => {
  return (
    <Container id="metodologia">
      <Title>Comparação com os métodos tradicionais</Title>
      
      <ComparisonTable>
        <TableHeader>
          <MethodsHeader>Métodos</MethodsHeader>
          <CoursesHeader>Cursos</CoursesHeader>
          <FluenciAHeader>
            FluencIA
          </FluenciAHeader>
        </TableHeader>
        
        <TableRow>
          <MethodColumn>Horário</MethodColumn>
          <CourseColumn>Fixo na semana</CourseColumn>
          <FluenciAColumn>Você escolhe</FluenciAColumn>
        </TableRow>
        
        <TableRow>
          <MethodColumn>Preço</MethodColumn>
          <CourseColumn>+20 mil reais investido</CourseColumn>
          <FluenciAColumn>R$ 59,90 mês</FluenciAColumn>
        </TableRow>
        
        <TableRow>
          <MethodColumn>Tempo</MethodColumn>
          <CourseColumn>Média 5 anos conclusão</CourseColumn>
          <FluenciAColumn>Média 14 meses para bom aprendizado</FluenciAColumn>
        </TableRow>
        
        <TableRow>
          <MethodColumn>Flexibilidade</MethodColumn>
          <CourseColumn>–</CourseColumn>
          <FluenciAColumn><CheckIcon>✓</CheckIcon></FluenciAColumn>
        </TableRow>
        
        <TableRow>
          <MethodColumn>Tecnologia</MethodColumn>
          <CourseColumn>–</CourseColumn>
          <FluenciAColumn><CheckIcon>✓</CheckIcon></FluenciAColumn>
        </TableRow>
        
        <TableRow>
          <MethodColumn>Certificações</MethodColumn>
          <FluenciAColumn><CheckIcon>✓</CheckIcon></FluenciAColumn>
          <FluenciAColumn><CheckIcon>✓</CheckIcon></FluenciAColumn>
        </TableRow>

        <TableRow>
          <MethodColumn>Custo Benefício</MethodColumn>
          <CourseColumn>–</CourseColumn>
          <FluenciAColumn><CheckIcon>✓</CheckIcon></FluenciAColumn>
        </TableRow>
      </ComparisonTable>
    </Container>
  );
};

export default Section3;
